export const FINAL_REPORT_STATUSES = [
  "completed",
  "outdatedByDoclist",
  "outdatedByTemplate",
  "failed",
] as const;

export function generateIdempotencyKey(): string {
  return typeof crypto !== "undefined" &&
    typeof (crypto as any).randomUUID === "function"
    ? (crypto as any).randomUUID()
    : `${Date.now()}-${Math.random().toString(36).slice(2)}`;
}
